// extracted by mini-css-extract-plugin
export var dividerLine = "_64-0";
export var errorBackground = "_64-1";